<label class="toggle" [ngClass]="size()" [class.is-disabled]="disabled()">
  <input
    class="toggle-checkbox"
    type="checkbox"
    [checked]="value()"
    [disabled]="disabled()"
    [attr.aria-label]="ariaLabel()"
    [name]="name()"
    (input)="toggleChecked()">
  <span class="toggle-switch"></span>
</label>
